import { render, staticRenderFns } from "./comprehensiveAnalysis.vue?vue&type=template&id=0a99f861&scoped=true&"
import script from "./comprehensiveAnalysis.vue?vue&type=script&lang=js&"
export * from "./comprehensiveAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./comprehensiveAnalysis.vue?vue&type=style&index=0&id=0a99f861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a99f861",
  null
  
)

export default component.exports